import { isServerRender, tswPlug } from '@/utils/env';
import { jsonToQueryString } from '@/utils/uri';
import config from '@/config';

let tdbank;
let fromIp; // 本机器的内网ip

if (isServerRender && tswPlug) {
  tdbank = tswPlug('api/tdbank');
  const serverInfo = tswPlug('serverInfo');
  fromIp = serverInfo && serverInfo.intranetIp;
}
const timeCache = {};
const intfaceInfo = {
  sysID: 9901108, // 秒级监控申请业务id
  intfID: 3, // 秒级监控申请的接口对应id
  totalCount: 1,
};
function requestCb(url, params) {
  if (!isServerRender || !tdbank) {
    return params;
  }
  const key = `${Date.now()}_${parseInt(Math.random() * 100, 10)}`;
  timeCache[key] = Date.now();
  params.plugCgiReport = key;
  return params;
}

function responseCb(url, params, result) {
  if (!isServerRender || !tdbank) {
    return;
  }
  if (url && url.indexOf(config.cgi.testHost) === 0) {
    intfaceInfo.intfID = 4;
  }
  if (params && params.plugCgiReport && timeCache[params.plugCgiReport]) {
    const requestParams = {
      ...intfaceInfo,
      netErrorCount: 0, // 网络异常
      logicErrorCount: (result && result.ret === 0) ? 0 : 1, // 逻辑异常
      serverErrorCount: (result && result.ret <= 0) ? 0 : 1, // 服务异常
      timeCost: Date.now() - timeCache[params.plugCgiReport],
      url: url.replace(/\?[^\s]+/, '').replace(/\//g, '-'),
      isFail: 0,
      code: result && result.ret,
      // eslint-disable-next-line no-useless-escape
      host: url.replace(/[\w]+:\/\/([^\/]+\.[\w]+)[\S]+/, '$1'),
      fromIp,
      toIp: (params.proxy && params.proxy.host) || '',
    };
    console.log('返回码', JSON.stringify(requestParams));
    tdbank.send('b_teg_rt_index', 'yoyo_api', jsonToQueryString(requestParams));
    delete timeCache[params.plugCgiReport];
  }
}

function errorCb(url, params, res) {
  if (!isServerRender || !tdbank) {
    return;
  }
  if (params && params.plugCgiReport && timeCache[params.plugCgiReport]) {
    const requestParams = {
      ...intfaceInfo,
      netErrorCount: 1, // 网络异常
      logicErrorCount: 0, // 逻辑异常
      serverErrorCount: 0, // 服务异常
      timeCost: Date.now() - timeCache[params.plugCgiReport],
      url: url.replace(/\?[^\s]+/, '').replace(/\//g, '-'),
      isFail: 1,
      code: res && res.status,
      host: url.replace(/[\w]+:\/\//, ''),
      fromIp,
      toIp: (params.proxy && params.proxy.host) || '',
      ...params,
    };
    console.log('返回码', JSON.stringify(requestParams));
    tdbank.send('b_teg_rt_index', 'yoyo_api', jsonToQueryString(requestParams));
    delete timeCache[params.plugCgiReport];
  }
}
export default {
  request: requestCb,
  response: responseCb,
  error: errorCb,
};
